import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { FORM_SELECTION_CONTROL_BASE_CLASSNAME } from './Constants';
import { createFormSelectionControl } from './FormSelectionControl';
createComponents(".".concat(FORM_SELECTION_CONTROL_BASE_CLASSNAME), createFormSelectionControl, NO_PATTERN_BUSINESS_LOGIC);
